<template>
    <PopupRouterViewDetail label="Mapping Andon Production Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Mapping Andon Production" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-andon-name" label-cols-lg="12"  label="Andon Name" label-for="input-andon-name" size="sm" :model.sync="model.andonName" :isRequired="true" :state="validateState('andonName')" :errorMessage="getErrorMessage(errorMessage.andonName, 'andonName')"  @change="updateData" :isUpdatable ="true"/>
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

		<app-table-input-popup title="Mapping Andon Prod Detail" :bordered="true" :items="mappingAndonProdDetails" :fields="fieldsMappingAndonProdDetail" :busy="isDataLoading" :sort-by.sync="sortByMappingAndonProdDetail" :sort-desc.sync="sortDescMappingAndonProdDetail" small responsive
			@editButtonMethod="editRowDataMappingAndonProdDetail"
			@deleteButtonMethod="deleteRowDataMappingAndonProdDetail"
			@showPopupAddMethod="resetDataMappingAndonProdDetail()"
			@showPopupUploadMethod="showPopupUploadMappingAndonProdDetail()"
			@downloadMethod="downloadMappingAndonProdDetail()"
			@addFromClipboardMethod="addFromClipboardMappingAndonProdDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardMappingAndonProdDetail()"
			:showActionButton="true"
			:showEditButton="false"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadMappingAndonProdDetail"
			>
			<template #top-row v-if="isShowMappingAndonProdDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Machine">
					<v-select append-to-body label="code" :options="machines"  :value="filterMappingAndonProdDetail.machineId" :reduce="item => item.id" v-model="filterMappingAndonProdDetail.machineId" @search="getMachines" :filterable="true"></v-select>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( mappingAndonProdDetailPageSize * (currentMappingAndonProdDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(machine)="row">
				<app-input-combobox-autocomplete :options="machines" optionsLabel="code" optionsKey="id" :id="'input-mapping-andon-prod-detail-machine-' + row.index" label-cols-lg="12" label="Machine" size="sm" :model.sync="row.item.machineId" :state="validateState('machineId')" :errorMessage="getErrorMessage(errorMessage.machineId, 'machineId')"  @change="saveInputMappingAndonProdDetail(row.item)" :selected="row.item.machine != null ? row.item.machine.code : ''"  @input="getMachines" :loading="isMachineComboLoading"  :isUpdatable="true"  :nolabel="true" />
			</template>

			<template v-slot:form-add-detail>
				<MappingAndonProdDetailInput 
					:openPopup="isShowPopupMappingAndonProdDetail"
					:modelId="mappingAndonProdDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataMappingAndonProdDetail"/>
			</template>
			<template v-slot:upload-detail>
				<MappingAndonProdDetailUpload
					:openPopup="isShowPopupUploadMappingAndonProdDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataMappingAndonProdDetail"
					:parentId="modelId"
					/>
			</template>

		</app-table-input-popup>
        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import MappingAndonProduction from '@/models/MappingAndonProduction/MappingAndonProduction';
import MappingAndonProductionList from '@/models/MappingAndonProduction/MappingAndonProductionList';
import MappingAndonProductionFilter from '@/filters/MappingAndonProduction/MappingAndonProductionFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import MappingAndonProdDetail from '@/models/MappingAndonProduction/MappingAndonProdDetail';
import MappingAndonProdDetailFilter from '@/filters/MappingAndonProduction/MappingAndonProdDetailFilter';
import Machine from '@/models/Machine/Machine';
import MachineFilter from '@/filters/Machine/MachineFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import MappingAndonProdDetailInput from '@/views/MappingAndonProduction/MappingAndonProdDetailInput';
import MappingAndonProdDetailUpload from '@/views/MappingAndonProduction/MappingAndonProdDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		AppInputComboboxAutocomplete,
		MappingAndonProdDetailInput,MappingAndonProdDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			andonName: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				andonName: { required : "Andon Name is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsMappingAndonProdDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"machine": { "class" : "th-machine first-child", "label" : "Machine", key: 'machine', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelMappingAndonProdDetail : {},
			isShowPopupMappingAndonProdDetail : false,
			isShowPopupUploadMappingAndonProdDetail : false,
			filterMappingAndonProduction : null,
			currentMappingAndonProductionPage : 1,
			mappingAndonProductionPageSize: 10,
			sortByMappingAndonProduction: '',
			sortDescMappingAndonProduction: '',
			filterMappingAndonProdDetail : null,
			currentMappingAndonProdDetailPage : 1,
			mappingAndonProdDetailPageSize: 10,
			sortByMappingAndonProdDetail: '',
			sortDescMappingAndonProdDetail: '',
			sortingByMappingAndonProdDetail: [],
			mappingAndonProdDetails : [],
			mappingAndonProdDetailId : '',
			totalMappingAndonProdDetailRow : 0,
			isShowMappingAndonProdDetailFilter: false,
			isDownloadMappingAndonProdDetail: false,
			machines: [],
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isMappingAndonProductionComboLoading: false,
			isMachineComboLoading: false,
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getMappingAndonProduction : async function(id) {
			this.isBusy = true;
			MappingAndonProduction.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadMappingAndonProduction = true;
			this.filterMappingAndonProduction.id = this.modelId;
			MappingAndonProduction.downloadDataDetail(this, this.filterMappingAndonProduction).then(result => {
				this.isDownloadMappingAndonProduction = false;
			}).catch(error => { this.isDownloadMappingAndonProduction = false; })
		},
		getMappingAndonProdDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterMappingAndonProdDetail);
			if (this.modelId == null) return;
			filter.mappingAndonProductionId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByMappingAndonProdDetail != null) {
				this.sortingByMappingAndonProdDetail[this.sortByMappingAndonProdDetail] = this.sortDescMappingAndonProdDetail;
			}
			let currentPage = (this.currentMappingAndonProdDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalMappingAndonProdDetailRow + 1;
				let page = Math.ceil(totalData/this.mappingAndonProdDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.mappingAndonProdDetailPageSize = 0;
			// disable paging end
			MappingAndonProdDetail.getList(this, filter, this.sortingByMappingAndonProdDetail, currentPage , this.mappingAndonProdDetailPageSize).then(result => {
				this.currentMappingAndonProdDetailPage = currentPage + 1;
				this.mappingAndonProdDetails = result.data;
				this.totalMappingAndonProdDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getMappingAndonProductions : async function(input) {
			let filter = new MappingAndonProductionFilter();
			if (input != undefined) {
				filter.AndonName = input;
			}
			this.isMappingAndonProductionComboLoading = true;
			MappingAndonProduction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.mappingAndonProductions = result.data
				}
				this.isMappingAndonProductionComboLoading = false;
			})
			.catch(error => {});
		},
		getMappingAndonProductions : async function(input) {
			let filter = new MappingAndonProductionFilter();
			if (input != undefined) {
				filter.andonName = input;
			}
			this.isMappingAndonProductionComboLoading = true;
			MappingAndonProduction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.mappingAndonProductions = result.data
				}
				this.isMappingAndonProductionComboLoading = false;
			})
			.catch(error => {});
		},
		getMachines : async function(input) {
			let filter = new MachineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isMachineComboLoading = true;
			Machine.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.machines = result.data
				}
				this.isMachineComboLoading = false;
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.mappingAndonProductionInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					MappingAndonProduction.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'mappingandonproductionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					MappingAndonProduction.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'mappingandonproductionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData(state) {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					MappingAndonProduction.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getMappingAndonProduction(id);
					});
				}
			});
		},
		onHidden() {
			this.getMappingAndonProductions();
		},
		addRowDataMappingAndonProdDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.mappingAndonProductionId =  this.modelId;
					MappingAndonProdDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getMappingAndonProdDetails(true);
						this.isShowPopupMappingAndonProdDetail = false;
					})
				} else {
					model.mappingAndonProductionId =  this.modelId;
					MappingAndonProdDetail.createDataDetail(this, model)
					.then(result => {
						this.getMappingAndonProdDetails(true);
						this.isShowPopupMappingAndonProdDetail = false;
					})
				}
			}
		},
		async editRowDataMappingAndonProdDetail(id) {
			this.mappingAndonProdDetailId = id;
			this.isShowPopupMappingAndonProdDetail = true; 
		},
		async deleteRowDataMappingAndonProdDetail(id) {
			MappingAndonProdDetail.deleteData(this, id).then(result => { this.getMappingAndonProdDetails(); });
		},
		async resetDataMappingAndonProdDetail() {
			this.mappingAndonProdDetailId = "";
			this.isShowPopupMappingAndonProdDetail = true;
		},
		async addDataMappingAndonProdDetail() {
			MappingAndonProdDetail.createData(this, { mappingAndonProductionId: this.modelId })
			.then(result => {
				this.getMappingAndonProdDetails(true);
			})
		},
		async addFromClipboardMappingAndonProdDetail() {
			let machines = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					machines.push({ machine: item, mappingAndonProductionId: this.modelId });
				});
				MappingAndonProdDetail.addFromClipboard(this, machines).then(result => { this.getMappingAndonProdDetails() });
			});
		},
		async replaceFromClipboardMappingAndonProdDetail() {
			let machines = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					machines.push({ machine: item, mappingAndonProductionId: this.modelId });
				});
				MappingAndonProdDetail.replaceFromClipboard(this, machines).then(result => { this.getMappingAndonProdDetails() });
			});   
		},
		showPopupUploadMappingAndonProdDetail() {
			if(this.mappingAndonProdDetails != null && this.mappingAndonProdDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap MappingAndonProdDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadMappingAndonProdDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadMappingAndonProdDetail = true;
			}
		},
		uploadDataMappingAndonProdDetail(modalEvent, newDatas) {
			this.isShowPopupUploadMappingAndonProdDetail = false; 
		},
		downloadMappingAndonProdDetail(modalEvent) {
			this.isDownloadMappingAndonProdDetail = true;
			this.filterMappingAndonProdDetail.mappingAndonProductionId = this.modelId;
			MappingAndonProdDetail.downloadDataDetail(this, this.filterMappingAndonProdDetail).then(result => {
				this.isDownloadMappingAndonProdDetail = false;
			}).catch(error => { this.isDownloadMappingAndonProdDetail = false; })
		},
		saveInputMappingAndonProdDetail(item) {
			if (this.mappingAndonProductions != null && this.mappingAndonProductions != undefined  && this.mappingAndonProductions.length > 0) {
				item.mappingAndonProduction = this.mappingAndonProductions.find(q => q.id == item.mappingAndonProductionId);
			}
			if (this.machines != null && this.machines != undefined  && this.machines.length > 0) {
				item.machine = this.machines.find(q => q.id == item.machineId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					MappingAndonProdDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadMappingAndonProdDetail = false; 
			this.isShowPopupMappingAndonProdDetail = false; 
			if (modalType == 'MappingAndonProdDetail') {
				this.getMappingAndonProdDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowMappingAndonProdDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterMappingAndonProduction = new MappingAndonProductionFilter();
		this.filterMappingAndonProdDetail = new MappingAndonProdDetailFilter();
		//this.getMappingAndonProductions();
		//this.getMachines();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getMappingAndonProduction(id);
			} else {
				this.modelId = id;
				this.getMappingAndonProduction(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByMappingAndonProdDetail : {
			handler: function() {
				this.getMappingAndonProdDetails();
			}
		},
		sortDescMappingAndonProdDetail: {
			handler: function() {
				this.getMappingAndonProdDetails();
			}
		},
		currentMappingAndonProdDetailPage: {
			handler: function() {
				this.getMappingAndonProdDetails();
			}
		},
		mappingAndonProdDetailPageSize : {
			handler: function() {
				this.getMappingAndonProdDetails();
			}
		},
		filterMappingAndonProdDetail: {
			handler: function() {
				this.getMappingAndonProdDetails();
			},
			deep: true,
		},
	},
}
</script>
